<template>
  <div class="wrapper"></div>
</template>

<script>
export default {};
</script>
<style lang="scss" scoped>
$xs: "320px";
$sm: "480px";
$md: "800px";
$lg: "1024px";
.wrapper {
  background: #5592c6 url(../assets/load.gif) center center no-repeat;
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 99999;
  background-size: 100px;
}
</style>
